/*  ==========================================================================
    IMPRESSIONS
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';

// local imports
import * as vars from '../../globals/variables';
import * as utils from '../../utilities/utils';

/*
 * MODULE
 */

export function initImpressions($element) {

    // magnific popup
    utils.mfp.initGallery($element);

    // initialize slider
    let $sliderContainer = $element.find('.bn-impressions__slider'),
        sliderOverrides = {
            fade: false,
            nextArrow: vars.slick_nextArrowV2,
            pauseOnHover: true,
            prevArrow: vars.slick_prevArrowV2
        };
    utils.slickCarousel.initSingleSlider($sliderContainer,sliderOverrides);

    $('.bn-impressions__head').each(function () {
        if($(this).find('.bn-impressions__title').length){
            $(this).addClass('bn-titleset');
        }
    });
}


// WEBPACK FOOTER //
// ./source/js/modules/lib/impressions.js